import { trim } from 'lodash-es'
export default (string) => trim(string).replace(/\s+/g, ' ')
